export default __webpack_public_path__ + "static/media/phone.b28a997b.svg";